'use client'
import { useContext } from 'react'
import { LocationContext } from '@/context'

export const useLocation = () => {
  const ctx = useContext(LocationContext)
  if (!ctx) throw new Error('useLocation must be used within a LocationContext')
  return ctx
}
